var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",class:_vm.location},[_c('footer-nav'),_c('p',{attrs:{"id":"copyright"}},[_vm._v("\n    "+_vm._s(_vm.copyright)+"\n  ")]),_c('noscript',[_vm._v("Copyright(C)BIGLOBE Inc.")]),_c('footer-image-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }